module.exports = __webpack_public_path__ + "a15e004129c1e58ff5b92daf3108b06c.fbx";